// extracted by mini-css-extract-plugin
module.exports =  {"content":"ZGW1sXHoqhafZVvQm5dR","totals":"RF7xyOcRPHvnYnXJpDrW","sent":"qNFC0WlxjegIeD1GXnKz"};